import { LocalStringToNumberPipe } from './local-string-to-number.pipe';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'getAbsolutePercentage' })
export class GetAbsolutePercentagePipe implements PipeTransform {

  /* transform(): Pipe que devuelve de acuerdo al valor absoluto de un número
    value: valor numérico
    type: Acción a realizar
    options: opciones con texto a retornar cuando el valor es negativo o positivo
    └ si se modifica la variable compare, entonces se devolverá el texto de acuerdo a un rango
    compare: Rangos para seleccionar una posición de array de opciones
  */
  transform(value: any, type: string, options?: string[], compare: number[] = [0], format = ","): string | number {
    // ↓ Convierte el valor a número dependiendo del formato recibido
    value = format === "," ? new LocalStringToNumberPipe().transform(value, "local") : Number(value);
    // ↓ Verifica si la variable options se declaro, sino agrega configuraciones de acuerdo al tipo
    options = options ? options : (type === 'color' ? ["danger", "success"] : ["▼", "▲"]);
    // valueToReturn: guarda el valor que se retornará
    let valueToReturn: string | number;
    switch (type) {
      // ↓ Opción para devolver el valor absoluto
      case 'value': valueToReturn = Math.abs(value); break;
      // ↓ Opción para devolver un valor del array options
      default:
        // ↓ Preselecciona la última opción
        valueToReturn = options[options.length - 1];
        // ↓ itera el array para calcular los rangos
        compare.forEach((elm: number, idx: number) => {
          elm = new LocalStringToNumberPipe().transform(elm.toString(), "local");
          // ↓ Si es la primera posición, valida con menor que
          if (idx === 0) { if (value < elm) { valueToReturn = options[idx]; } } else {
            // ↓ Si no es la primera posición, valida que esté entre entre el rango valor anterior y valor actual
            if (value < elm && value >= compare[idx - 1]) { valueToReturn = options[idx]; }
          }
        });
        break;
    }
    // ↓ Devuelve el resultado
    return valueToReturn;
  }

}
